let Logout = {
  showLoader: false,
  loadingMsg: "",
  /**
   * meshLogout
   */
  async meshLogout (context) {
    if (!context) {
      return
    }

    // Logging out oof mesh via iframe by redirecting to /mesh_logout
    let meshUrl = process.env.VUE_APP_MESH_SERVER_URL + `/mesh_logout`
    context.$store.dispatch("MeshUrl/setMeshUrl", meshUrl)

    // wait for some time and let the LS of mesh get cleared
    await new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, 3000)
    })
  },
  /**
   * signOut
   */
  async signOut (context) {
    if (!context) {
      return
    }

    try {
      context.isLoggingOut = true
      await context.meshLogout(context)
      if (window.location.hostname.toLowerCase().includes("gide.ai") ||
        (process.env.VUE_APP_ENV != "prod" && process.env.VUE_APP_ENV != "uat")
      ) {
        await context.$gAuth.signOut()
      }
      await context.$store.commit("User/setUserLogout")
    }
    catch (err) {
      console.error("Exception occurred at signout() and Exception:", err.message)
    }

    setTimeout(async () => {
      await context.$router.push("/login")
      context.isLoggingOut = false
      window.location.reload()
    }, 200)
  }
}

export default Logout
